import { useLoader } from "@/context/loaderContext";
import api from "@/components/customAxios/Axios";
import { useEffect, useState } from "react";
import { useToast } from "../toast";
import { useJobDetails } from "@/context/JobDetailsContext";



const JobDescriptionTextArea = () => {
	const { setLoading } = useLoader();
	const [wordCount, setWordCount] = useState(0);
	const { jobDetails, setJobDetails, primaryRequirements, secondaryRequirements } = useJobDetails();
	const toast = useToast()
	useEffect(() => {
		if (!jobDetails?.description) return;
		const tempWordCount = jobDetails?.description
			.trim()
			.split(/\s+/)
			.filter((word) => word).length;
		setWordCount(tempWordCount);
	}, [jobDetails?.description]);
	const getJobDescription = async (e: any) => {
		e.preventDefault();
		try {
			setLoading(true);
			const response = await api.post("/generate_jd", {
				role: jobDetails?.title,
				requirements: jobDetails?.description,
				yearsOfExperience: jobDetails?.experience,
				workLocationType: jobDetails?.type,
				location: jobDetails?.location,
				noticePeriod: jobDetails?.noticePeriod,
				salaryRange: jobDetails?.currency + " " + jobDetails?.salary + " " + jobDetails?.salaryPer,
				primarySkills: primaryRequirements,
				secondarySkills: secondaryRequirements
			});
			setJobDetails({ ...jobDetails, description: response.data.jd });

			setJobDetails({ ...jobDetails, description: response.data.jd });

		} catch (error: any) {
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Error generation JD",
				description:
					error.response?.data?.error || error.response?.data?.message ||
					"An error occurred, please try again later.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};




	return (
		<div>
			<div className="mb-6 relative border-0">
				<p className="text-gray-500  mb-2 px-2">Job Description <span className="text-red-500">*</span></p>
				<textarea
					id="message"
					required
					value={jobDetails?.description}
					className="w-full px-4 h-[200px] py-2 border  border-gray-300 rounded-lg "
					placeholder="Provide your job requirements in 10 to 100 words, or share the full description – let the AI handle the rest effortlessly"
					onChange={(e) => setJobDetails({ ...jobDetails, description: e.target.value })}
				/>
				<div className="absolute flex bottom-4 right-4 space-x-3">

					<button
						className={`
						
						bg-[#438437] text-white px-4 py-2 rounded  focus:ring-4 focus:outline-none 
						${!(
								(jobDetails?.title &&
									primaryRequirements && primaryRequirements.length > 0 &&
									secondaryRequirements && secondaryRequirements.length > 0 &&
									jobDetails?.experience) ||
								(jobDetails?.title && wordCount >= 10 && wordCount <= 100)
							)
								? "bg-[#BDE4C3] text-black cursor-not-allowed"
								: "bg-[#438437] text-white  hover:scale-110 transition"
							} `}
						onClick={getJobDescription}
						disabled={!(
							(jobDetails?.title &&
								primaryRequirements && primaryRequirements.length > 0 &&
								secondaryRequirements && secondaryRequirements.length > 0 &&
								jobDetails?.experience) ||
							(jobDetails?.title && wordCount >= 10 && wordCount <= 100)
						)}
					>
						Generate with AI
					</button>
				</div>
			</div>
			{/* <ReactQuill
				theme="snow"
				value={jobDescription}
				// onChange={setJobDescription}
			/> */}
		</div>
	);
};

export default JobDescriptionTextArea;
